// This is a part of the Cadcorp SIS source code. 
// Copyright (c) Cadcorp Limited 1991-2025 
import { IRootStateBase, IInteractiveSnackbar } from '../../../../../../CommonScripts/Abstractions';
import { Module } from 'Vuex';

const theState: IInteractiveSnackbar = {
    show: false,
    message: '',
    buttonText: '',
    callback: () => { },
    showActivity: false
};

export const interactiveSnackbarState: Module<IInteractiveSnackbar, IRootStateBase> = {
    namespaced: true,
    state: theState,
    actions: {
    },
    mutations: {
        setShow(state, show: boolean): void {
            state.show = show;
        },
        setMessage(state, message: string): void {
            state.message = message;
        },
        setbuttonText(state, buttonText: string): void {
            state.buttonText = buttonText;
        },
        setCallback(state, callback: () => void) {
            state.callback = callback;
        },
        setInteractiveSnackBar(state, snackBar: IInteractiveSnackbar) {
            state.buttonText = snackBar.buttonText;
            state.show = snackBar.show;
            state.callback = snackBar.callback;
            state.message = snackBar.message;
            state.showActivity = snackBar.showActivity;
        }
    }
};

